module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_7042.9927ddfd.png";